<template>
    <div class="root" v-loading="loading">
        <router-link to="/" replace>
            <div class="header">
                <!-- <div class="iconfont back-icon">&#xe624;</div> -->
                <div class="iconfont">返回</div>
            </div>
        </router-link>

        <div style="display:flex; color:#fff; width: 90vw; margin:0px auto 0 auto;">
            <div style="flex:1;">
            </div>
            <div>
                {{ step + 1 }}/50
            </div>
        </div>

        <div class="questiondiv">



<el-collapse v-model="activeNames"  accordion>
  <el-collapse-item  :title="item.id + '/' +item.title" :name="item.id" v-for="(item) in list" :key="item.id">
      <div v-html="item.desc" style="line-height:0.45rem; background-color: #f1f1f1;"></div>
  </el-collapse-item>
  
</el-collapse>


<div v-if="false">
            <div v-for="(item, index) in list" :key="item.id">
                <div v-if="step == index">
                    <div class="questiontitle">
                        {{ index + 1 }}、{{ item.title }}
                    </div>
                    <div v-html="item.desc" style="line-height:0.45rem;">
                        
                    </div>
                    <div class="questionoptions">
                        <div   :class="op.status==1?'selected option':'option'" v-for="(op,oindex) in item.options" :key="op.id">
                            {{ op.code }}、{{ op.txt }}
                        </div>
                    </div>
                    
            <div class="errmsg" v-if="item.err==1">
                *请选择一项
            </div>
                </div>
            </div>

            <div class="mybtns">
                <div style="flex:1;" v-if="step==0"></div>
                <div v-show="step>0" class="btnpre" @click="prequestion()">上一题</div>
                <div v-show="step<count-1" class="btnnext" @click="nextquestion()">下一题</div>
                <div style="flex:1;" v-if="step>=count-1"></div>
            </div>
            </div>
        </div>

        <el-dialog title="提示" :visible.sync="dialogVisible" width="80%">
            <span>确定提交吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleClose()">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>

import axios from 'axios'

export default {
    name: 'wenda',
    data: function () {
        return {
            activeNames: ['1'],
            radio: '1',
            loading:true,
            list: [],
            step: 0,
            flag: null,
            one: '00', // 时
            two: '00', // 分
            three: '00', // 秒
            abc: 0, // 秒的计数
            cde: 0, // 分的计数
            efg: 0, // 时的计数
            time:1800,
            fen:'00',
            miao:'00',
            dialogVisible: false,
            count:0
        }
    },
    components: {

    },
    methods: {

        prequestion() {
            this.step--;
        },
        nextquestion(){
            var step = this.step;
            this.step++;
        },
        getHomeInfo() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Question/list',
                {
                    limit: 50,
                    uid: 21,
                    token: '339c3ee5d33caaa31497cc8016aa4283'
                }
            )
                .then(this.getHomeInfoSucc)
        },
        getHomeInfoSucc(res) {
            this.loading=false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                if(res.toresult==1){
                    this.$router.replace('/result');
                }else{
                this.list = res.list
                this.count = res.list.length;
                console.log(this.list);
                }
            }else{
                if(res && res.Code == 301){
                    localStorage.removeItem('userJson');
                    this.$router.replace('/');
                }
            }
        },


    },
    mounted() {
        this.getHomeInfo()
    },
    beforeDestroy() {
        
    }
}
</script>
<style scoped>
.root {
    background-image: url("../../assets/imgs/bj.png");
    background-repeat: repeat;
    width: 100%;
    height: 100vh;
    overflow-y: scroll;
}

.header {
    padding: .24rem;
}

.back-icon {
    font-size: .4rem;
    color: #fff;
}

.questiondiv {
    height: calc(100vh - 115px);
    overflow-y: auto;
    background: #fff;
    width: 90vw;
    margin: 5px auto 5vh auto;
    padding: 12px;
    border-radius: 5px;
    box-sizing: border-box;
    max-width: 930px;
}

.questiontitle {
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 10px;
}

.option {
    font-size: 18px;
    margin-bottom: 10px;
    border: 1px #f1f1f1 solid;
    padding: 10px;
    line-height: 22px;
}

.option.selected {
    background: #BA0109;
    color: #fff;
}

.mybtns{
    width: 80vw;
    display: flex;
    margin: 20px auto;
    max-width: 330px;
}
.btnpre{
flex: 1;
margin-right: 10px;
color:#e6a23c;
text-align: center;
padding:10px;
border-radius: 1000px;
border:1px solid #e6a23c;
cursor: pointer;
}
.btnnext{
flex: 1;
margin-left: 10px;
color:#fff;
text-align: center;
padding:10px;
border-radius: 1000px;
background: #e6a23c;
cursor: pointer;
}
.btnsubmit{
flex: 1;
margin-left: 10px;
color:#fff;
text-align: center;
padding:10px;
border-radius: 1000px;
background: #67c23a;
}
.errmsg{
    color:red;
    width: 90vw;
    margin:10px auto;
}
.questiondiv >>> .VJbwyy{
    display: none;
}
.questiondiv >>> pre{
        word-wrap: normal;
    word-break: break-all;
    white-space: pre;
    overflow-x: scroll;
    overscroll-behavior-x: contain;
    margin-top: 0;
    margin-bottom: 20px;
    border-radius: 4px;
    z-index: 0;
    padding: 1em;
    line-height: 1.5;
    color: #ccc;
    background: #2d2d2d;
}
.questiondiv >>> img{
    max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/wenda/wenda.vue